import React, {
  createContext, SetStateAction, Dispatch, useState, ReactNode,
} from 'react';
/**
 * The Help Popup Context
 */
export const VersionHistoryPopupContext = createContext<boolean>(
  false,
);

export const VersionHistoryDispatchContext = createContext<
  Dispatch<SetStateAction<boolean>>>(undefined);

export function VersionHistoryProvider({ children }: { children: ReactNode }) {
  const [isVersionHistoryPopupOpen, setVersionHistoryPopupOpen] = useState(false);

  return (
    <VersionHistoryPopupContext.Provider
      value={isVersionHistoryPopupOpen}
    >
      <VersionHistoryDispatchContext.Provider value={setVersionHistoryPopupOpen}>
        {children}
      </VersionHistoryDispatchContext.Provider>
    </VersionHistoryPopupContext.Provider>
  );
}
